var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOldestIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12V0H3v12H.5L4 15.5 7.5 12H5zM10.5 2a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h2a.5.5 0 000-1H11V2.5a.5.5 0 00-.5-.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5c0-2.757 2.243-5 5-5s5 2.243 5 5v.5a.5.5 0 01-1 0V5c0-2.206-1.794-4-4-4S7 2.794 7 5a4.007 4.007 0 003 3.873V7l3 2.5-3 2.5V9.899A5.01 5.01 0 016 5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldestIcon);
export default __webpack_public_path__ + "static/media/oldest-icon.84a39ae255d7084cc5fbb9aefbf38cc2.svg";
export { ForwardRef as ReactComponent };